<template>
  <div class="base-height recording">
    <header>
      <b>underConstruction </b><i class="material-icons"> warning</i>
      <h1>NOBA LAB</h1>
      <p>{{ $t("phrase.easyEncoding") }}</p>
    </header>
    <div class="title">{{ $t("phrase.startEncoding") }}</div>
    <section>
      <div>
        <div class="uploader">
          <div v-if="file" class="filename">
            {{ file.name }}
            <button class="cancel" @click="handleFileDelete">
              <i class="material-icons">close</i>
            </button>
          </div>
          <div v-else>
            <div class="circle"></div>
            <i class="large material-icons">upload</i>
            <p>Drag&Drop or <span>Choose File</span></p>
            <input
              type="file"
              class="audio-file"
              ref="audio"
              @change="sendFile('audio')"
              accept="audio/mp3, audio/ogg,audio/wav,audio/mpeg,audio/webm,audio/midi"
            />
          </div>
        </div>
        <div class="progress">
          <div v-show="progress > 0 || progress == 0" class="progress-bar">
            <progress-bar :options="options" :value="progress" />
          </div>
          <div v-show="output" class="progress-bar">
            <span>{{ output }}</span>
            <a :href="url" download>
              <i class="material-icons">get_app</i>
            </a>
          </div>
        </div>
        <section class="recording-box">
          <div class="btn-group">
            <button
              class="recording-roundBtn red"
              v-show="progress == null"
              @click="encoding"
            >
              <i class="material-icons">sync</i>
            </button>
          </div>
          <div>
            <div class="select-group">
              <select v-model="encodingType">
                <option disabled value>type</option>
                <option value="wav">wav</option>
                <option value="mp3">mp3</option>
                <option value="ogg">ogg</option>
              </select>
              <select v-model="channel">
                <option disabled value>channel</option>
                <option value="1">1 channel</option>
                <option value="2">2 channel</option>
                <option value="4">4 channel</option>
                <option value="8">8 channel</option>
              </select>
              <select v-model="bitRate">
                <option disabled value>bitRate</option>
                <option value="64">64 Kbps</option>
                <option value="128">128 Kbps</option>
                <option value="160">160 Kbps</option>
                <option value="192">192 Kbps</option>
                <option value="224">224 Kbps</option>
                <option value="256">256 Kbps</option>
              </select>
              <select v-model="sampleRate">
                <option disabled value>sampleRate</option>
                <option value="32000">32000 khz</option>
                <option value="44100">44100 khz</option>
                <option value="48000">48000 khz</option>
              </select>
              <select></select>
            </div>
          </div>
        </section>

        <div class="process">
          <div class="process-box">
            <i class="large material-icons">file_upload</i>
            <h1>Upload</h1>
            {{ $t("phrase.encode1") }}
          </div>
          <i class="large material-icons">keyboard_arrow_right</i>
          <div class="process-box">
            <i class="large material-icons">sync</i>
            <!-- <img src="../../assets/images/processing.png"> -->
            <h1>Processing</h1>
            {{ $t("phrase.encode2") }}
          </div>
          <i class="large material-icons">keyboard_arrow_right</i>
          <div class="process-box">
            <i class="large material-icons">file_download</i>
            <h1>Download</h1>
            {{ $t("phrase.encode3") }}
          </div>
        </div>
      </div>
    </section>

    <section>
      <div class="ad-box">{{ $t("advertise") }}</div>
    </section>
    <!-- <p label="Sound Name">{{ title }}</p> -->
    <Usage />
  </div>
</template>
<script>
import axios from "axios";
import Usage from "@/components/Usage";
import ProgressBar from "vuejs-progress-bar";
import { createEncoding, fetchProgress } from "@/api/index";
import { mapState } from "vuex";
import { eventBus } from "@/main";
import { baseUrl } from "@/config/env";
import { uploadFile } from "@/api/index";
export default {
  components: { Usage, ProgressBar },
  data() {
    return {
      baseUrl: baseUrl,
      visible: false,
      blob: "",
      progress: null,
      setProgress: "",
      encodingType: "",
      channel: "",
      bitRate: "",
      sampleRate: "",
      file: "",
      output: "",
      url: "",
      options: {
        text: {
          color: "#FFFFFF",
          shadowEnable: true,
          shadowColor: "#000000",
          fontSize: 14,
          fontFamily: "Helvetica",
          dynamicPosition: false,
          hideText: false,
        },
        progress: {
          color: "#2dbd2d",
          backgroundColor: "#333333",
        },
        layout: {
          height: 35,
          width: 300,
          verticalTextAlign: 61,
          horizontalTextAlign: 43,
          zeroOffset: 0,
          strokeWidth: 30,
          progressPadding: 0,
          type: "line",
        },
      },
    };
  },
  created() {
    this.$store.dispatch("SET_NAVBAR", 2);
  },
  mounted() {
    eventBus.$on("closeModal", (message) => {
      this.closeModal();
      this.stop();
      this.progress = null;
      this.setProgress = "";
      this.encodingType = "";
      this.channel = "";
      this.bitRate = "";
      this.sampleRate = "";
      console.log(this.progress);
      console.log(this.setProgress);
      console.log(this.encodingType);
      console.log(this.channel);
    });
  },
  computed: {
    ...mapState(["isLogin"]),
    percent() {
      return this.progress;
    },
  },
  methods: {
    closeModal() {
      this.visible = false;
    },
    handleFileDelete() {
      this.file = "";
      this.output = "";
      this.url = "";
      this.progress = null;
      this.setProgress = "";
      this.encodingType = "";
      this.channel = "";
      this.bitRate = "";
      this.sampleRate = "";
    },
    sendFile() {
      this.file = this.$refs.audio.files[0];
    },
    stop() {
      clearInterval(this.setProgress);
      this.setProgress = "";
    },
    encoding() {
      if (!this.isLogin) {
        return alert("로그인 후 사용 가능 합니다.");
      }
      this.progress = 0; //프로그래스 바 0% 부터 시작하도록 값을 넣어줌.
      let formdata = new FormData();
      formdata.append("file", this.file);
      formdata.append("encodingType", this.encodingType);
      formdata.append("channel", this.channel);
      formdata.append("bitRate", this.bitRate);
      formdata.append("sampleRate", this.sampleRate);
      this.setProgress = setInterval(() => {
        fetchProgress().then((res) => {
          window.console.log("progress", this.progress);
          this.progress = res.data.progress;
        });
      }, 1000);
      createEncoding(formdata).then((res) => {
        if (res.data.status === 200) {
          this.stop(); //프로그래스 상태 중지
          this.progress = 100;
          this.output = res.data.data.output;
          this.url = res.data.data.url;
          this.bitRate = res.data.data.output_bitrate;
          this.channel = res.data.data.output_channel;
          this.sampleRate = res.data.data.output_sampleRate;
          this.encodingType = res.data.data.output_encodingType;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
header {
  width: 100%;
  height: 350px;
  background: url("../../assets/images/main-bg.jpg") no-repeat center center;
  background-size: cover;
  color: #fff;
  padding-top: 100px;
  margin-top: 62px;
  text-shadow: 2px 2px 3px rgba(0, 0, 0, 0.3);
  font-size: 1.6rem;
  letter-spacing: 1px;
  h1 {
    font-size: 4.5rem;
    letter-spacing: 0.5rem;
    margin: 2rem 0;
  }
  i {
      vertical-align:bottom;
  }
  text-align: center;
}
.title {
  font-size: 2.2rem;
  margin-top: 5rem;
  text-align: center;
  span {
    color: #ff5252;
  }
}
.progress-bar {
  width: 70%;
  margin: 40px auto;
  display: flex;
  justify-content: center;
  .vuejs-progress-bar {
    width: 100%;
    text-align: center;
  }
  span {
    height: 40px;
    border: 2px solid #313da1;
    line-height: 25px;
    padding: 5px 40px;
    border-radius: 4px 0px 0px 4px;
  }
  a {
    height: 40px;
    width: 40px;
    // line-height: 60px;
    background: #313da1;
    padding: 5px;
    color: #fff;
    display: flex;
    vertical-align: middle;
    border-radius: 0px 4px 4px 0px;
    i {
      margin: 0 auto;
      padding-top: 2px;
    }
  }
}
.uploader {
  margin: 50px auto;
  max-width: 800px;
  height: 220px;
  text-align: center;
  border: 1px solid #313da1;
  border-radius: 4px;
  background: linear-gradient(#ffffff, #f2f2f2);
  position: relative;
  i {
    line-height: 72px;
    font-size: 40px;
    color: #313da1;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    border: 3px solid #313da1;
    position: absolute;
    top: 50px;
    left: calc(50% - 40px);
  }
  .circle {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    border: 1px solid #acb3f58e;
    position: absolute;
    top: 50px;
    left: calc(50% - 40px);
    animation: scale 1s infinite alternate;
  }
  @keyframes scale {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(1.3);
    }
  }
  &:hover {
    border: 2px solid rgb(52, 64, 153);
    cursor: pointer;
  }
  img {
    width: 400px;
    margin-top: 40px;
  }
  p {
    font-size: 1.5rem;
    color: #000;
    text-align: center;
    font-weight: 500;
    position: absolute;
    bottom: 40px;
    left: 50%;
    transform: translateX(-50%);
  }
  .audio-file {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100% !important;
    opacity: 0%;
    &:hover {
      cursor: pointer;
    }
  }
  .filename {
    width: 100%;
    height: 100%;
    line-height: 220px;
    .cancel {
      margin-left: 20px;
      width: 30px;
      height: 30px;
      background: #313da1;
      border-radius: 50%;
      position: relative;
      i {
        width: 100%;
        color: #fff;
        font-size: 24px;
        position: absolute;
        top: 60%;
        left: 50%;
        transform: translate(-50%, -50%);
        border: none;
      }
    }
  }
}
.ad-box {
  max-width: 800px;
  margin: 40px auto;
  height: 100px;
  border: 1px solid #eee;
  border-radius: 4px;
}

.recording-box {
  max-width: 800px;
  height: 100px;
  margin: 0 auto;
  border-radius: 5px;
  position: relative;
  .select-group {
    width: 100%;
    height: 100px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    background: linear-gradient(#ffffff, #f2f2f2);
    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.1);
    position: absolute;
    padding-left: 3rem;
    top: 0;
    left: 0;
    select {
      width: 12rem !important;
      height: 3.4rem !important;
      // background-color: $primary;
      // color: #fff;
    }
    select:nth-child(5) {
      visibility: hidden;
    }
  }
}
.btn-group {
  max-width: 800px;
  margin: 40px auto;
  height: 100px;
  border-radius: 15px;
  background: linear-gradient(#ffffff, #f2f2f2);
  display: flex;
  justify-content: space-evenly;
  text-align: center;
  display: flex;
  justify-content: center;
  .recording-roundBtn {
    margin: 25px;
    width: 50px;
    height: 50px;
    // border: 2px solid blue;
    border-radius: 50%;
    color: #ffffff;
    text-align: center;
    font-size: 15px;
    cursor: pointer;
    z-index: 10;
    position: absolute;
    right: 5%;
    i {
      font-size: 30px;
    }
    &.red {
      background-color: #ff5252;
      border: 1px solid rgba(255, 255, 255, 0.9);
      box-shadow: 0 3px 6px rgba(33, 33, 33, 0.1),
        0 3px 12px rgba(33, 33, 33, 0.15);
    }
    &.black {
      box-shadow: 0 3px 6px rgba(33, 33, 33, 0.1),
        0 3px 12px rgba(33, 33, 33, 0.15);
      color: black;
      border: 1px solid rgba(255, 255, 255, 0.9);
    }
    &.white {
      border: 1px solid #111;
      background-color: #fff;
      i {
        color: #111;
      }
    }
  }
}

@media all and (max-width: 1200px) {
  header {
    height: 250px;
    padding-top: 60px;
  }
  .ad-box {
    width: calc(100% - 60px);
  }
  .uploader {
    width: calc(100% - 60px);
  }
  .recording-box {
    width: calc(100% - 60px);
  }
}

@media screen and (max-width: 540px) {
  header {
    height: 200px;
    padding-top: 30px;
    h1 {
      font-size: 4rem;
      margin: 2.4rem 0;
    }
  }
  .title {
    font-size: 2rem;
    margin-top: 4rem;
    padding: 0 20px;
  }
  .ad-box {
    margin: 6rem auto 1rem;
    height: 80px;
    border: 1px solid #eee;
  }
  .progress-bar {
    width: 100%;
    margin: 20px auto;
    span {
      height: 40px;
      line-height: 25px;
      padding: 5px 10px;
    }
    a {
      height: 40px;
      width: 40px;
      padding: 5px;
    }
  }
  .uploader {
    margin: 4rem auto;
    height: 140px;
    i {
      line-height: 56px;
      font-size: 40px;
      width: 60px;
      height: 60px;
      border: 2px solid #313da1;
      left: calc(50% - 30px);
      top: 25px;
    }
    .circle {
      width: 60px;
      height: 60px;
      left: calc(50% - 30px);
      top: 25px;
    }
    &:hover {
      border: 2px solid rgb(52, 64, 153);
      cursor: pointer;
    }
    p {
      font-size: 1.5rem;
      bottom: 20px;
      width: 100%;
    }
    .filename {
      line-height: 140px;
      .cancel {
        margin-left: 5px;
        width: 25px;
        height: 25px;
        > i {
          font-size: 20px;
        }
      }
    }
  }
  .recording-box {
    margin-bottom: 4rem;
    .select-group {
      height: 90px;
      justify-content: space-evenly;
      flex-direction: column;
      flex-wrap: wrap;
      padding: 0;
      padding-left: 10px;
      select {
        margin: 0;
      }
    }
  }
  .btn-group {
    width: 100%;
    margin: 0 auto;
    height: 90px;
    .recording-roundBtn {
      &.red {
        margin: 20px 10px;
      }
    }
  }
}

@media all and (max-width: 376px) {
  header {
    font-size: 1.5rem;
    h1 {
      font-size: 4rem;
      margin: 2rem 0;
    }
  }
  .title {
    font-size: 2rem;
    margin-top: 2.5rem;
  }
  .ad-box {
    width: calc(100% - 20px);
  }
  .progress-bar {
    span {
      max-width: 260px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    a {
      height: 40px;
      width: 40px;
      padding: 5px;
    }
  }
  .uploader {
    width: calc(100% - 20px);
    .filename {
      font-size: 1.4rem;
      line-height: normal;
      padding-top: 50px;
      text-align: center;
      overflow: hidden;
      .cancel {
        display: inline-block;
        margin: 5px;
      }
    }
  }
  .recording-box {
    width: calc(100% - 20px);
    .select-group {
      select {
        width: 11rem !important;
        height: 3.4rem !important;
        margin-right: 5px;
      }
    }
  }
  .btn-group {
    .recording-roundBtn {
      &.red {
        margin: 20px 5px;
      }
    }
  }
}
</style>
